export const MENU_CATEGORIES_INIT = 'MENU_CATEGORIES_INIT';
export const MENU_CATEGORIES_RESET = 'MENU_CATEGORIES_RESET';
export const MENU_CATEGORIES_CHANGE = 'MENU_CATEGORIES_CHANGE';


export const menuCategoriesThunk = (id) => {

  return function (dispatch) {
    dispatch({
      type: MENU_CATEGORIES_CHANGE,
      id
    })
  }
}
